export default {
    data() {
        return {
            TABLE_TYPES: {
                COL1: 1,
                COL2: 2,
                COL3: 3,
                COL4: 4,
                COL5: 5,
                COL6: 6,
                CTA: 7,
                COL24: 8,
            },
            TABLE_CELL_TYPES: {
                TEXT: 1,
                TEXT_WITH_ICON: 2,
                LINK: 3,
                LOGO: 4,
                LOGO_WITH_LINK: 5,
                REFERENCE_LABEL: 6,
                REFERENCE_VALUE: 7,
                REFERENCE_VALUE_WITH_LINK: 8,
            },
        };
    },
};
